$(document).ready(() => {
  $.rails.allowAction = function (link) {
    if (!link.attr('data-confirm')) {
      return true;
    }
    $.rails.showConfirmDialog(link);
    return false;
  };
  $.rails.confirmed = function (link) {
    link.removeAttr('data-confirm');
    return link.trigger('click.rails');
  };
  return $.rails.showConfirmDialog = function (link) {
    const message = link.attr('data-confirm');
    const html = '<div class="modal" id="confirmationDialog"> <div class="modal-dialog"> <div class="modal-content"> <div class="modal-header"> <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" /> </div> <div class="modal-body">' + message + '</div> <div class="modal-footer"> <a data-bs-dismiss="modal" class="btn btn-secondary" href="#">' + link.data('cancel') + '</a> <a data-bs-dismiss="modal" class="btn btn-primary confirm" href="#">' + link.data('ok') + '</a> </div> </div> </div> </div>';
    bootstrap.Modal.getOrCreateInstance($(html)).show();
    return $('#confirmationDialog .confirm').on('click', function () {
      return $.rails.confirmed(link);
    });
  };
});
